import React from 'react';
import HubSpotForm from '../../../components/common/HubSpotForm';

interface BrandInvestmentFormProps {
  data?: {
    heading?: string;
    subheading?: string;
    button_text?: string;
    form_title?: string;
  };
  onDownloadGuide?: () => void;
}

export const BrandInvestmentForm: React.FC<BrandInvestmentFormProps> = ({
  data,
  onDownloadGuide
}) => {
  const heading =
    data?.heading ||
    'Are you an investor looking to learn more about the investment returns Golden Tower provides?';
  const subheading = data?.subheading || 'Download Our Investor Guide Now';
  const buttonText = data?.button_text || 'Download Guide';
  const formTitle = data?.form_title || 'Register for Investor Details';

  const scrollToForm = () => {
    const el = document.getElementById('investment-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else if (onDownloadGuide) {
      onDownloadGuide();
    }
  };

  return (
    <section id="investment" className="relative py-28 md:py-36 bg-[#0a0a0f] text-white border-t border-white/5 overflow-hidden">
      {/* Background ambient lighting */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-96 bg-gradient-to-b from-[#C5A46D]/10 via-transparent to-transparent pointer-events-none" />

      <div className="container mx-auto px-6 max-w-5xl relative z-10">
        
        {/* Investment Opportunities Banner */}
        <div className="text-center space-y-6 mb-20 bg-gradient-to-b from-white/[0.04] to-transparent border border-white/10 rounded-3xl p-8 md:p-14 shadow-2xl">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#C5A46D]/10 border border-[#C5A46D]/30 text-[#C5A46D] text-xs uppercase tracking-[0.25em] font-medium">
            Investment Opportunities
          </div>

          <h2 className="text-2xl md:text-4xl lg:text-5xl font-light leading-snug max-w-3xl mx-auto text-white">
            {heading}
          </h2>

          <p className="text-lg md:text-xl text-[#C5A46D] font-medium tracking-wide">
            {subheading}
          </p>

          <div className="pt-2">
            <button
              onClick={scrollToForm}
              className="inline-flex items-center gap-2.5 px-9 py-4 bg-[#C5A46D] hover:bg-[#b8955e] text-black font-semibold rounded-full text-xs md:text-sm tracking-[0.2em] uppercase transition-all duration-300 shadow-xl shadow-[#C5A46D]/20 cursor-pointer"
            >
              <i className="ri-download-cloud-line text-lg"></i>
              {buttonText}
            </button>
          </div>
        </div>

        {/* Form Section */}
        <div id="investment-form" className="max-w-2xl mx-auto bg-[#12121a] border border-white/10 rounded-3xl p-6 sm:p-10 md:p-12 shadow-2xl">
          <div className="text-center mb-8 space-y-2">
            <h3 className="text-2xl md:text-3xl font-light text-white">
              {formTitle}
            </h3>
            <p className="text-sm text-gray-400">
              Please fill in your details below to receive the complete investor pack & floor plans.
            </p>
          </div>

          <HubSpotForm
            onSuccess={() => {
              if (onDownloadGuide) onDownloadGuide();
            }}
          />
        </div>

      </div>
    </section>
  );
};

export default BrandInvestmentForm;
